<template>
  <div class="cookie-container" v-if="showDialog">
    <input class="checkbox-cb" id="checkbox-cb" type="checkbox" />
    <div class="cookie-bar">
      <span class="message">
       Questo sito utilizza cookie tecnici e di profilazione propri e di terze parti per le sue funzionalità e per inviarti pubblicità, contenuti e servizi più vicini ai tuoi gusti e interessi. Chiudendo questo messaggio, scorrendo questa pagina o cliccando qualunque suo elemento acconsenti all'uso dei cookie per le finalità indicate. Per negare il consenso a tutti o ad alcuni cookie o anche solo per saperne di più fai
        <a
          target="_blank" href="/info/privacy"
        >click qui</a>.
      </span>
      <span class="mobile">
        Questo sito utilizza cookie tecnici e di profilazione propri e di terze parti per le sue funzionalità e per inviarti pubblicità, contenuti e servizi più vicini ai tuoi gusti e interessi. Chiudendo questo messaggio, scorrendo questa pagina o cliccando qualunque suo elemento acconsenti all'uso dei cookie per le finalità indicate. Per negare il consenso a tutti o ad alcuni cookie o anche solo per saperne di più fai,
        <a href="/info/privacy" target="_blank">click qui</a>.
      </span>
      <button class="close-cb" @click="acceptCookieConsent();showDialog=false">x</button>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
    data() {
        return {
            showDialog: false,
        }
    },
    mounted() {
        const cookieConsent = Cookies.get("accepted_cookies");
        const scrollFunc = () => {
          this.acceptCookieConsent();
          this.showDialog = false;
          removeListeners();
        };

        const clickFunc = () => {
          this.acceptCookieConsent();
          this.showDialog = false;
          removeListeners();
        };

        const removeListeners = () => {
          window.removeEventListener('scroll', scrollFunc);
          window.removeEventListener('click', clickFunc);
        };

        if(!cookieConsent) {
            window.addEventListener('scroll', scrollFunc, true);

            document.addEventListener('click', clickFunc, true);
            this.showDialog = true;
        }
    },
    methods: {
        acceptCookieConsent() {
            Cookies.set("accepted_cookies", true);
        }
    }
};
</script>
<style lang="scss" scoped>
.cookie-bar {
  position: fixed;
  width: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  height: auto;
  text-align: center;
  line-height: 30px;
  background: black;
  z-index:1;
  color: white;
  font-size: 14px;
  font-family: "Verdana", sans-serif;
  font-weight: 100;
  transition: 0.8s;
  animation: slideIn 0.8s;
  animation-delay: 0.8s;
  .message {
    word-break: break-word;
    @media (max-width: 767px) {
      display: none;
    }
  }
  .mobile {
    display: none;
    @media (max-width: 767px) {
      display: inline-block;
    }
  }
}
@keyframes slideIn {
  0% {
    transform: translateY(-50px);
  }
  100% {
    transform: translateY(0);
  }
}
.close-cb {
  border: none;
  color: white;
  background: darken(black, 20%);
  display: inline-block;
  right: 10px;
  top: 0;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.2);
  line-height: 30px;
  height: 30px;
  width: 30px;
  font-size: 16px;
  font-weight: bold;
  &:hover {
    background: darken(black, 10%);
  }
}
.checkbox-cb {
  display: none;
  &:checked + .cookie-bar {
    transform: translateY(-50px);
  }
}
a {
  color: rgb(92, 242, 255);
}
</style>